import { FETCH_MTOKNA_SELLER_NOTES, CLEAN_MTOKNA_SELLER_NOTES, CHANGE_MTOKNA_SELLER_NOTE, DELETE_MTOKNA_SELLER_NOTE } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_SELLER_NOTES_DEFAULT_STATE = {};

const MtoknaSellerNotesReducer = (state = MTOKNA_SELLER_NOTES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_SELLER_NOTES:
            return payload;

        case CHANGE_MTOKNA_SELLER_NOTE:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, settings: payload.settings };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_SELLER_NOTES:
        case DELETE_MTOKNA_SELLER_NOTE:
            return MTOKNA_SELLER_NOTES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaSellerNotesReducer;
